/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ContractRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/policyholder-data/policyholder-data.module').then(m => m.PolicyholderDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_CONTACT.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/policyholder-contact/policyholder-contact.module').then(
        m => m.PolicyholderContactPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.POLICYHOLDER_ADDRESS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/policyholder-address/policyholder-address.module').then(
        m => m.PolicyholderAddressPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.ERROR_CLIENT.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/error-verti-client/error-verti-client.module').then(m => m.ErrorVertiClientPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.TAX_DEDUCTION_PROFESSION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/tax-deduction/tax-deduction.module').then(m => m.TaxDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.PARTNER_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/partner-data/partner-data.module').then(m => m.PartnerDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.PREVIOUS_INSURANCE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/contract/previous-insurance/previous-insurance.module').then(m => m.PreviousInsurancePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.PAYMENT.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/payment/payment.module').then(m => m.PaymentPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.CONTRACT.SEPA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/contract/sepa/sepa.module').then(m => m.SepaPageModule),
    canActivate: [NavigationGuard],
  },
  {
      path: RoutePaths.NEW_QUOTATION.CONTRACT.BAD_CLIENT.route,
      loadChildren: () => import('@pages/contract/bad-client/bad-client.module').then(m => m.BadClientPageModule),
      canActivate: [NavigationGuard],
    },
];
